import {
  BulbOutlined,
  EuroOutlined,
  FileImageOutlined,
  InfoCircleOutlined,
  ShopOutlined,
  SkinOutlined,
} from "@ant-design/icons";
import { useQuery } from "@apollo/client";
import { Button, Layout, Menu, PageHeader, Row, Typography } from "antd";
import { CenterSpinner } from "components/CenterSpinner";
import gql from "graphql-tag";
import React, { Fragment, useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useParams } from "react-router-dom";

const articleItemQuery = gql`
  query($id: ID!) {
    articleItem(id: $id) {
      id
      code
      referenceItem {
        id
        code
      }
    }
  }
`;

export const Show: React.FC<{}> = () => {
  const location = useLocation();
  const { id } = useParams();
  const variables = { id };
  const { loading, data } = useQuery(articleItemQuery, { variables, fetchPolicy: "cache-and-network" });

  const [selectedKey, setSelectedKey] = useState<string[]>(["details"]);

  useEffect(() => {
    if (location.pathname.includes("/images")) setSelectedKey(["images"]);
    else if (location.pathname.includes("/variants")) setSelectedKey(["variants"]);
    else if (location.pathname.includes("/sizes")) setSelectedKey(["sizes"]);
    else if (location.pathname.includes("/prices")) setSelectedKey(["prices"]);
    else if (location.pathname.includes("/suggestions")) setSelectedKey(["suggestions"]);
    else if (location.pathname.includes("/stocks")) setSelectedKey(["stocks"]);
    else setSelectedKey(["details"]);
  }, [location.pathname]);

  if (loading) return <CenterSpinner size="large" />;

  const item = data.articleItem;

  return (
    <Fragment>
      <Layout.Header className="header-background">
        <Row justify="space-between">
          <Menu theme="light" mode="horizontal">
            <Menu.Item className="no-border">
              <Typography.Title level={4} style={{ lineHeight: "auto" }}>
                Item: {item.code}
              </Typography.Title>
            </Menu.Item>
          </Menu>
          <Menu theme="light" mode="horizontal">
            <Menu.Item className="no-border">
              <NavLink to={item.referenceItem ? `../${item.referenceItem.id}/variants` : "../"}>
                <Button>Back</Button>
              </NavLink>
            </Menu.Item>
          </Menu>
        </Row>
      </Layout.Header>
      <Layout className="content">
        <Layout>
          <Layout.Content className="content">
            {item.referenceItem && (
              <PageHeader ghost={false} style={{ padding: "1px 24px" }}>
                <Typography.Title level={4}>
                  Variant of:
                  <NavLink to={`../${item.referenceItem.id}`}>{` ${item.referenceItem.code}`}</NavLink>
                </Typography.Title>
              </PageHeader>
            )}
            <Layout className="show-sidebar-bg" style={{ padding: "24px 0" }}>
              <Layout.Sider className="show-sidebar-bg" width={200}>
                <Menu mode="inline" key={`${selectedKey}`} defaultSelectedKeys={selectedKey} style={{ height: "100%" }}>
                  <Menu.Item key="details" icon={<InfoCircleOutlined />}>
                    <NavLink to="./">
                      <span> Details</span>
                    </NavLink>
                  </Menu.Item>
                  {!item.referenceItem && (
                    <Menu.Item key="variants" icon={<SkinOutlined />}>
                      <NavLink to="./variants">
                        <span> Variants</span>
                      </NavLink>
                    </Menu.Item>
                  )}
                  <Menu.Item key="images" icon={<FileImageOutlined />}>
                    <NavLink to="./images">
                      <span> Images</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="prices" icon={<EuroOutlined />}>
                    <NavLink to="./prices">
                      <span> Prices</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="suggestions" icon={<BulbOutlined />}>
                    <NavLink to="./suggestions">
                      <span> Suggestions</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="stocks" icon={<ShopOutlined />}>
                    <NavLink to="./stocks">
                      <span> Stocks</span>
                    </NavLink>
                  </Menu.Item>
                </Menu>
              </Layout.Sider>
              <Layout.Content>
                <Outlet />
              </Layout.Content>
            </Layout>
          </Layout.Content>
        </Layout>
      </Layout>
    </Fragment>
  );
};
